import { useEffect, useRef } from 'react'

const RAISE_NAMES = { 1: 'um', 3: 'truco', 6: 'seis', 9: 'nove', 12: 'doze' }

function raiseName(value) {
  return RAISE_NAMES[value] || String(value)
}

const rankNames = {
  '4': '4', '5': '5', '6': '6', '7': '7',
  'Q': 'Dama', 'J': 'Valete', 'K': 'Rei', 'A': 'Ás', '2': '2', '3': '3',
}
const suitNames = {
  ouros: 'Ouros', espadas: 'Espadas', copas: 'Copas', paus: 'Paus',
}

export default function ResponseDialog({ pendingRaise, playerHand, manilhaRank, onAccept, onEscalate, onDecline, onClose }) {
  const dialogRef = useRef(null)
  const previousFocus = useRef(null)

  useEffect(() => {
    if (pendingRaise) {
      previousFocus.current = document.activeElement
      const firstBtn = dialogRef.current?.querySelector('button:not([disabled])')
      if (firstBtn) firstBtn.focus()
    } else if (previousFocus.current) {
      previousFocus.current.focus()
      previousFocus.current = null
    }
  }, [pendingRaise])

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key !== 'Tab') return
      const dialog = dialogRef.current
      if (!dialog) return
      const focusable = dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }

    if (pendingRaise) {
      window.addEventListener('keydown', handleKeyDown)
      return () => window.removeEventListener('keydown', handleKeyDown)
    }
  }, [pendingRaise])

  if (!pendingRaise) return null

  return (
    <div
      ref={dialogRef}
      id="response-dialog"
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="response-dialog-heading"
    >
      <div className="modal-content">
        <h2 id="response-dialog-heading">Responder ao pedido</h2>
        <p id="response-dialog-desc">
          O computador pediu {raiseName(pendingRaise.requested_value)}. O que você deseja fazer?
        </p>

        {playerHand && playerHand.length > 0 && (
          <div className="modal-hand" aria-label="Suas cartas para decisão">
            <h3>Suas cartas</h3>
            <div className="cards-container">
              {playerHand.map((card, index) => {
                const name = `${rankNames[card.rank] || card.rank} de ${suitNames[card.suit] || card.suit}`
                return (
                  <button
                    key={index}
                    type="button"
                    className="card-btn"
                    disabled
                  >
                    {name}
                  </button>
                )
              })}
            </div>
          </div>
        )}

        {manilhaRank && (
          <div className="modal-manilha" aria-label="Manilha atual">
            <p>
              Manilha: <strong>{rankNames[manilhaRank] || manilhaRank}</strong>
            </p>
          </div>
        )}

        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-primary btn-large"
            id="btn-accept"
            onClick={onAccept}
          >
            Aceitar
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-large"
            id="btn-escalate"
            onClick={onEscalate}
          >
            Aumentar
          </button>
          <button
            type="button"
            className="btn btn-danger btn-large"
            id="btn-decline"
            onClick={onDecline}
          >
            Correr
          </button>
        </div>
      </div>
    </div>
  )
}
